import { memo, useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { DataTable, DataTablePagination } from 'components/common'
import { usePageAccess, useQuery } from 'hooks'
import { fetchFtpConfigurations } from 'utils/api/ftpConfigurationApi'
import { getColumns } from './utils'

type Props = {
  aggregators: any[]
  refetchConfig?: boolean
}

const FtpConfigurationsTable = ({ aggregators, refetchConfig }: Props) => {
  const { isEditor } = usePageAccess()

  const [ftpConfigurationsData, setFtpConfigurationsData] = useState<any>({})

  const { search } = useLocation()
  const { getQuery } = useQuery()

  const columns = getColumns({
    isEditor,
    aggregators,
  })

  const getFtpConfigurations = async () => {
    try {
      const { data } = await fetchFtpConfigurations({
        limit: getQuery('limit') || 10,
        page: getQuery('page') || 1,
      })
      setFtpConfigurationsData({ ...data })
    } catch (error) {
      setFtpConfigurationsData({ docs: [] })
    }
  }

  useEffect(() => {
    getFtpConfigurations()
  }, [search, refetchConfig])

  return (
    <>
      <h3 className="title">Current FTP Configurations</h3>

      <DataTable
        columns={columns}
        rows={ftpConfigurationsData?.docs}
        identifier="_id"
      />

      <DataTablePagination
        currentPage={ftpConfigurationsData?.page}
        totalPages={ftpConfigurationsData?.totalPages}
        hasNextPage={ftpConfigurationsData?.hasNextPage}
        hasPrevPage={ftpConfigurationsData?.hasPrevPage}
        limit={ftpConfigurationsData?.limit}
        nextPage={ftpConfigurationsData?.nextPage}
        prevPage={ftpConfigurationsData?.prevPage}
      />
    </>
  )
}

export default memo(FtpConfigurationsTable)
